var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1.2vw",
    height: "1vw",
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_311_20509)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 14,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0001 9.33341C11.3144 9.33341 12.381 8.28808 12.381 7.00008C12.381 5.71208 11.3144 4.66675 10.0001 4.66675C8.68581 4.66675 7.61914 5.71208 7.61914 7.00008C7.61914 8.28808 8.68581 9.33341 10.0001 9.33341ZM10.0001 8.40008C10.7887 8.40008 11.4287 7.77288 11.4287 7.00008C11.4287 6.22728 10.7887 5.60008 10.0001 5.60008C9.21152 5.60008 8.57152 6.22728 8.57152 7.00008C8.57152 7.77288 9.21152 8.40008 10.0001 8.40008Z",
    fill: "#1A47B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0006 7.46654C10.2636 7.46654 10.4768 7.2576 10.4768 6.99987C10.4768 6.74214 10.2636 6.5332 10.0006 6.5332C9.73761 6.5332 9.52441 6.74214 9.52441 6.99987C9.52441 7.2576 9.73761 7.46654 10.0006 7.46654Z",
    fill: "#1A47B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 9.625H20V14H0V9.625Z",
    fill: "#249F58"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H20V4.375H0V0Z",
    fill: "#FF6C2D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_311_20509"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 14,
    rx: 2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.9fc6d54559393733920f4c30213f992c.svg";
export { ForwardRef as ReactComponent };